import { render, staticRenderFns } from "./AccountPayment.vue?vue&type=template&id=90b920e8"
import script from "./AccountPayment.vue?vue&type=script&lang=js"
export * from "./AccountPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports